import React, { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import AddEditSource from "./AddEditSource";
import { updateSource, useSources } from "services/sourcesService";
import { toast } from "react-toastify";
import { GridLoader } from "components/GridLoader";

const SourcesList = () => {
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const { data: sourcesList, loading: isLoading } = useSources();

  const enterEdit = (item) => {
    setIsEditFormOpen(true);
    setEditItem(item);
  };

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const dataToPost = {
        ...data,
        active: data.active ?? true,
      };
      const result = await updateSource(data.sourceID, dataToPost);
      if (result.success) {
        toast.success("Source updated successfully");
        setIsEditFormOpen(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditFormOpen(false);
    setEditItem(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid data={sourcesList || []} style={{ height: "100%" }} showLoader={isLoading} loader={
        <div style={{ height: "50px" }}>
          <GridLoader />
        </div>
      }>
        <GridNoRecords>
          {isLoading ? (
            <span></span>
          ) : (
            sourcesList && sourcesList?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column
          field="sourceName"
          title=" "
          width="80px"
          cell={(props) => <SignatureCell {...props} />}
        />
        <Column field="sourceName" title="Name" width="200px" />
        <Column field="sourceDetails" title="Details" />
        <Column
          cell={ActiveCell}
          title="Active"
          field="active"
          width="80px"
        />
        <Column title="Edit" cell={MyEditCommandCell} width="60px" />
      </Grid>

      {isEditFormOpen && (
        <AddEditSource
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          type="edit"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default SourcesList;
